import update from 'immutability-helper'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_AD_ACCOUNTS,
  GET_AD_ACCOUNTS_FAILURE,
  GET_AD_ACCOUNTS_SUCCESS,
  SET_SELECTED_AD_ACCOUNTS,
  GET_AD_ACCOUNT,
  GET_AD_ACCOUNT_SUCCESS,
  GET_AD_ACCOUNT_FAILURE,
  CLEAR_ALL_PLATFORMS_SINGLE_AD_ACCOUNT,
  CLEAR_SPECIFIC_PLATFORM_SINGLE_AD_ACCOUNT
} from '../actions/adAccounts'

import { INITIAL_GET_REDUCER, INITIAL_GET_RESULTS_REDUCER } from '../../constants/reducer'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_AD_MANAGER_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  selectedAdAccounts: {
    [FACEBOOK_PLATFORM]: {},
    [GOOGLE_PLATFORM]: {},
    [DV_360_PLATFORM]: {},
    [TIKTOK_PLATFORM]: {},
    [GOOGLE_AD_MANAGER_PLATFORM]: {},
    wasSelected: false
  },
  adAccounts: INITIAL_GET_RESULTS_REDUCER,
  adAccount: {
    [FACEBOOK_PLATFORM]: INITIAL_GET_REDUCER,
    [GOOGLE_PLATFORM]: INITIAL_GET_REDUCER,
    [DV_360_PLATFORM]: INITIAL_GET_REDUCER,
    [TIKTOK_PLATFORM]: INITIAL_GET_REDUCER,
    [GOOGLE_AD_MANAGER_PLATFORM]: INITIAL_GET_REDUCER
  }
}

export default function adAccounts(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    // get ad accounts
    case GET_AD_ACCOUNTS:
      return update(state, {
        adAccounts: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_AD_ACCOUNTS_SUCCESS:
      return update(state, {
        adAccounts: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.adAccountsData
          }
        }
      })
    case GET_AD_ACCOUNTS_FAILURE:
      return update(state, {
        adAccounts: {
          $merge: {
            isLoading: true,
            error: action.error
          }
        }
      })
    case SET_SELECTED_AD_ACCOUNTS:
      return update(state, {
        selectedAdAccounts: {
          $set: {
            ...action.selectedAdAccounts,
            wasSelected: true
          }
        }
      })

    // get ad account
    case GET_AD_ACCOUNT:
      return update(state, {
        adAccount: {
          [action.platform]: {
            $merge: {
              isLoading: true
            }
          }
        }
      })
    case GET_AD_ACCOUNT_SUCCESS:
      return update(state, {
        adAccount: {
          [action.platform]: {
            $merge: {
              isLoading: false,
              data: action.adAccountData,
              wasLoaded: true
            }
          }
        }
      })
    case GET_AD_ACCOUNT_FAILURE:
      return update(state, {
        adAccount: {
          [action.platform]: {
            $merge: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })
    case CLEAR_ALL_PLATFORMS_SINGLE_AD_ACCOUNT:
      return update(state, {
        adAccount: { $set: initialState.adAccount }
      })
    case CLEAR_SPECIFIC_PLATFORM_SINGLE_AD_ACCOUNT:
      return update(state, {
        adAccount: {
          [action.platform]: { $set: initialState.adAccount[action.platform] }
        }
      })
    default:
      return state
  }
}
